import PracticeBaseError from 'errors/PracticeBaseError';

export default class PracticeProfileError extends PracticeBaseError {
  position: string[] = []
  agreed_contracts?: string[] = []
  affiliate_code: string[] = []
  marketing_channel: string[] = []
  parent_company: string[] = []
}